// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__EnsP8","load2":"Spinner__load2__3if5d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Spinner/Spinner.css
// module id = 427
// module chunks = 17